<mat-dialog-content class="mat-typography">
  <img src="../assets/img/Abonummer_auf_Umschlag.JPG" alt="Abonummer_auf_Umschlag" width="450" height="200"> 
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="button-styles" [mat-dialog-close]="true">{{ 'DATAPOLICY.CLOSE_BUTTON' | translate }}</button>
</mat-dialog-actions>